export default __webpack_public_path__ + "static/media/hotel_img_hi_24.de19dd7a.jpg";